import { SignIn, SignUp } from "@clerk/clerk-react";

export function Login() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-100 via-white to-sky-50 p-4">
      {/* Decorative elements */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-sky-200 rounded-full opacity-30 blur-3xl" />
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-sky-300 rounded-full opacity-20 blur-3xl" />

      <div className="relative z-10">
        <SignIn
          routing="path"
          path="/login"
          signUpUrl="/signup"
          fallbackRedirectUrl="/dashboard"
          appearance={{
            elements: {
              rootBox: "mx-auto",
              card: "shadow-xl border border-slate-200",
            },
          }}
        />
      </div>
    </div>
  );
}

export function Signup() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-100 via-white to-sky-50 p-4">
      {/* Decorative elements */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-sky-200 rounded-full opacity-30 blur-3xl" />
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-sky-300 rounded-full opacity-20 blur-3xl" />

      <div className="relative z-10">
        <SignUp
          routing="path"
          path="/signup"
          signInUrl="/login"
          fallbackRedirectUrl="/dashboard"
          appearance={{
            elements: {
              rootBox: "mx-auto",
              card: "shadow-xl border border-slate-200",
            },
          }}
        />
      </div>
    </div>
  );
}

export default Login;
